export default "__VITE_ASSET__BHlhTjW0__"